import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { HomeComponent } from './home/home.component';
import { ServiceComponent } from './service/service.component';
import { EntitlementServiceComponent } from './entitlement/entitlement-service/entitlement-service.component';
import { EntitlementServiceClientComponent } from './entitlement/entitlement-service-client/entitlement-service-client.component';
import { EntitlementClientComponent } from './entitlement/entitlement-client/entitlement-client.component';
import { ClientComponent } from './client/client.component';
import { ApiDocumentComponent } from './api-document/api-document.component';

const isIframe = window !== window.parent && !window.opener;

const routes: Routes = [
  {
    path: 'entitlement-service/:serviceId',
    component: EntitlementServiceComponent,
    canActivate: [MsalGuard],
  },
  {
    path: 'entitlement-service-client/:clientId/:serviceId',
    component: EntitlementServiceClientComponent,
    canActivate: [MsalGuard],
  },
  {
    path: 'entitlement-client/:clientId',
    component: EntitlementClientComponent,
    canActivate: [MsalGuard],
  },
  {
    path: 'service',
    component: ServiceComponent,
    canActivate: [MsalGuard],
  },
  {
    path: 'client',
    component: ClientComponent,
    canActivate: [MsalGuard],
  },
  {
    path: 'document/api-document',
    component: ApiDocumentComponent,
    canActivate: [MsalGuard],
  },
  {
    path: '',
    component: HomeComponent,
    canActivate: [MsalGuard],
  },
  {
    path: '**',
    redirectTo: '',
    canActivate: [MsalGuard],
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: false,
      initialNavigation: !isIframe ? 'enabledBlocking' : 'disabled',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
